import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ICase } from '../interfaces/cases.interface';
import { RouterLink } from '@angular/router';
import { BalanceType } from '@core/types/balance.type';
import { BalanceIconComponent } from '../../../core/components/balance-icon/balance-icon.component';
import { DecimalPipe } from '@angular/common';
@Component({
  selector: 'app-cases-case',
  imports: [RouterLink, BalanceIconComponent, DecimalPipe],
  templateUrl: './cases-case.component.html',
  styleUrl: './cases-case.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.--color]': 'caseItem().color ?? "var(--yellow)"',
  },
})
export class CasesCaseComponent {
  caseItem = input.required<ICase>();
  balance = input.required<BalanceType>();
}
